import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll the window to the top on every route change.
 *
 * Without this, React Router preserves scroll position across navigations,
 * which can hide the top of newly-rendered pages (hero, header, etc).
 * Mount this once inside <BrowserRouter>.
 */
export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // Use `instant` so the user never sees the previous scroll position flash.
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname]);

    return null;
}
